import { useRef } from 'react';
import useTimer from '../../utils/hooks/useTimer.js';
import { findNextIndexByValue } from './util.js';

var useTypeahead = function useTypeahead(_ref) {
  var data = _ref.data,
      currentIndex = _ref.currentIndex;
  var typeaheadQuery = useRef();
  var typeaheadQueryTimer = useTimer(1000, function () {
    typeaheadQuery.current = undefined;
  });

  var getNextIndex = function getNextIndex(charKey) {
    var query = (typeaheadQuery.current ? typeaheadQuery.current + charKey : charKey).toLowerCase();
    var nextIndex = findNextIndexByValue(data, query, currentIndex);
    typeaheadQueryTimer.start();
    typeaheadQuery.current = query;
    return nextIndex;
  };

  return {
    getNextIndex: getNextIndex
  };
};

export { useTypeahead };
//# sourceMappingURL=useTypeahead.js.map
